import Select, { components } from 'react-select';
import styles from './MultiSelectDropdown.module.scss';
import { getDefaultSelectStyles } from './MultiSelectDropdown.constants';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { Checkbox } from '../Checkbox';
const Option = (props) => {
  return (
    <components.Option {...props}>
      <Checkbox
        checked={props.isSelected}
        onChange={() => null}
        id={props.label}
      />
      <label>{props.label}</label>
    </components.Option>
  );
};
export const MultiSelectDropdownComponent = ({
  options,
  value,
  onChange,
  isLoading,
  isDisabled,
  classNamePrefix,
  selectStyles,
  label,
  errorMessage,
  placeholder,
  // Portal target for the open menu — pass `document.body` when nesting
  // inside a clipped-overflow container (e.g. Modal) so it isn't cut off.
  menuPortalTarget,
}) => {
  return (
    <div className={styles.dropdownContainer}>
      <Text
        variant={textVariantsEnum.Text_13}
        fontWeight={fontWeightEnum.Medium}
        className={styles.label}
      >
        {label}
      </Text>
      <Select
        isMulti={true}
        options={options}
        value={value}
        onChange={onChange}
        isLoading={isLoading}
        isDisabled={isDisabled}
        placeholder={placeholder}
        classNamePrefix={classNamePrefix}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{ Option }}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPortalTarget ? 'fixed' : undefined}
        styles={{
          ...getDefaultSelectStyles(selectStyles),
          ...(menuPortalTarget
            ? { menuPortal: (base) => ({ ...base, zIndex: 1200 }) }
            : {}),
        }}
      />
      {!!errorMessage && (
        <Text
          variant={textVariantsEnum.Text_13}
          fontWeight={fontWeightEnum.Regular}
          color="error-500"
        >
          {errorMessage}
        </Text>
      )}
    </div>
  );
};
